export default __webpack_public_path__ + "static/media/trustpilot.9404da02.svg";